import React from "react";
import * as Yup from "yup";
import { FormContainer } from "~/views/persons/styles";
import { isValidCpf } from "~/helper";
import Tabs from '~/components/tabs';
import { TabGeneral } from "~/views/persons/tab-general";
import { TabCovid } from "~/views/persons/tab-covid";

export const PersonSchema = (fromGroup) =>
  Yup.object().shape({
    name: Yup.string().required("Informe o nome"),
    identify: Yup.mixed().test(
      "",
      "Informe o CPF ou Número de registro",
      function(value) {
        let parent = this.parent || {};

        if (!parent.source || parent.source === "national") {
          return value && isValidCpf(value);
        }
        return !!value;
      }
    ),
    role: Yup.object().required('Selecione a função'),
  }); 

const tabs = [
  { id: "general", label: "Dados gerais", component: TabGeneral },
  { id: "covid", label: "Protocolo COVID", component: TabCovid },
];

export const PersonForm = (args) => {
  return (
    <FormContainer>
      <Tabs tabs={tabs} initialTab="general" {...args} />
    </FormContainer>
  );
};
